import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: any) => ({
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  statusFilter: {
    width: 353,
    maxWidth: '100%',
  },
  rowActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
  cellText: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  reasonText: {
    display: 'flex',
    alignItems: 'baseline',
    maxWidth: 360,
    minWidth: 0,
  },
  reasonPreview: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  showMoreLink: {
    color: '#cc092f',
    background: 'transparent',
    border: 0,
    padding: 0,
    marginLeft: theme.spacing(0.5),
    font: 'inherit',
    cursor: 'pointer',
    verticalAlign: 'baseline',
    flexShrink: 0,
    '&:hover': { color: '#a80728' },
  },
  reasonTooltip: {
    maxWidth: 500,
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    fontSize: theme.typography.body2.fontSize,
  },
}));
